import { useQuery } from '@tanstack/react-query';
import instance from '@src/api/axiosInstance';

interface AnalysisTagsResponse {
  tags: string[];
  count: number;
}

const getAnalysisTags = async (): Promise<AnalysisTagsResponse> => {
  const response = await instance.get('/nexa/analysis-templates/tags');
  return response.data;
};

export const useGetAnalysisTags = () => {
  return useQuery({
    queryKey: ['analysis-tags'],
    queryFn: getAnalysisTags,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
